import React from "react";
import { ShieldCheck, IndianRupee, Headphones, Repeat } from "lucide-react";
import { useLang } from "../lib/LangContext";
import { heroImages } from "../lib/mock";

const ICONS = [ShieldCheck, IndianRupee, Headphones, Repeat];

export const Trust = () => {
  const { t } = useLang();
  return (
    <section className="bg-lokam-sand">
      <div className="px-6 md:px-12 lg:px-20 max-w-[1400px] mx-auto py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Image side */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src={heroImages.trust}
                alt="Indian families"
                className="block w-full h-[460px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-lokam-forest/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-lokam-cream">
                <div className="inline-flex items-center gap-2 rounded-full bg-lokam-cream/15 backdrop-blur-md border border-white/20 px-3 py-1.5 text-[11px] uppercase tracking-[0.2em] font-bold">
                  For your parents · For your kids · For you
                </div>
              </div>
            </div>
          </div>

          {/* Text side */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-lokam-tangerine">
              {t.trust.eyebrow}
            </p>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-lokam-forest text-balance">
              {t.trust.title}
            </h2>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {t.trust.points.map((p, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div
                    key={i}
                    data-testid={`trust-point-${i}`}
                    className="rounded-2xl bg-white border border-lokam-border p-6 hover:-translate-y-1 hover:shadow-lg transition-all"
                  >
                    <div className="h-10 w-10 rounded-xl bg-lokam-forest text-lokam-cream flex items-center justify-center">
                      <Icon className="h-5 w-5" />
                    </div>
                    <div className="mt-4 font-display font-semibold text-lokam-ink text-lg leading-tight">
                      {p.title}
                    </div>
                    <p className="mt-2 text-sm text-lokam-ink-soft leading-relaxed">
                      {p.body}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trust;
